/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  ModelApiResponse,
  RequestOrderCreateOne,
  ResponseInternalServerError,
  ResponseOrderGetList,
  ResponseOrderGetOne,
  ResponseOrderGetSums,
} from '../models/index'
import {
  ModelApiResponseFromJSON,
  ModelApiResponseToJSON,
  RequestOrderCreateOneFromJSON,
  RequestOrderCreateOneToJSON,
  ResponseInternalServerErrorFromJSON,
  ResponseInternalServerErrorToJSON,
  ResponseOrderGetListFromJSON,
  ResponseOrderGetListToJSON,
  ResponseOrderGetOneFromJSON,
  ResponseOrderGetOneToJSON,
  ResponseOrderGetSumsFromJSON,
  ResponseOrderGetSumsToJSON,
} from '../models/index'

export interface OrderCreateOneRequest {
  enterpriseId: string
  requestOrderCreateOne?: RequestOrderCreateOne
}

export interface OrderDeleteOneRequest {
  enterpriseId: string
  orderId: string
}

export interface OrderGetListRequest {
  enterpriseId: string
  shopId?: string
  shopSalePointId?: string
  shopPaymentPointId?: string
  userId?: string
  fromDate?: string
  toDate?: string
  limit?: number
  offset?: number
}

export interface OrderGetOneRequest {
  enterpriseId: string
  orderId: string
}

export interface OrderGetSumsInShopRequest {
  enterpriseId: string
  shopId: string
}

export interface OrderGetSumsInShopPaymentPointRequest {
  enterpriseId: string
  shopId: string
  shopSalePointId: string
  shopPaymentPointId: string
}

export interface OrderGetSumsInShopPaymentPointsRequest {
  enterpriseId: string
  shopId: string
  shopSalePointId: string
}

export interface OrderGetSumsInShopSalePointRequest {
  enterpriseId: string
  shopId: string
  shopSalePointId: string
}

export interface OrderGetSumsInShopSalePointsRequest {
  enterpriseId: string
  shopId: string
}

export interface OrderGetSumsInShopsRequest {
  enterpriseId: string
}

export interface OrderUpdateOneRequest {
  enterpriseId: string
  orderId: string
  requestOrderCreateOne?: RequestOrderCreateOne
}

/**
 *
 */
export class OrderApi extends runtime.BaseAPI {
  /**
   */
  async orderCreateOneRaw(
    requestParameters: OrderCreateOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOrderGetOne>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderCreateOne().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RequestOrderCreateOneToJSON(
          requestParameters['requestOrderCreateOne'],
        ),
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOrderGetOneFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderCreateOne(
    requestParameters: OrderCreateOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOrderGetOne> {
    const response = await this.orderCreateOneRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async orderDeleteOneRaw(
    requestParameters: OrderDeleteOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ModelApiResponse>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderDeleteOne().',
      )
    }

    if (requestParameters['orderId'] == null) {
      throw new runtime.RequiredError(
        'orderId',
        'Required parameter "orderId" was null or undefined when calling orderDeleteOne().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order/{orderId}`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )
    urlPath = urlPath.replace(
      `{${'orderId'}}`,
      encodeURIComponent(String(requestParameters['orderId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ModelApiResponseFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderDeleteOne(
    requestParameters: OrderDeleteOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ModelApiResponse> {
    const response = await this.orderDeleteOneRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async orderGetListRaw(
    requestParameters: OrderGetListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOrderGetList>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderGetList().',
      )
    }

    const queryParameters: any = {}

    if (requestParameters['shopId'] != null) {
      queryParameters['shopId'] = requestParameters['shopId']
    }

    if (requestParameters['shopSalePointId'] != null) {
      queryParameters['shopSalePointId'] = requestParameters['shopSalePointId']
    }

    if (requestParameters['shopPaymentPointId'] != null) {
      queryParameters['shopPaymentPointId'] =
        requestParameters['shopPaymentPointId']
    }

    if (requestParameters['userId'] != null) {
      queryParameters['userId'] = requestParameters['userId']
    }

    if (requestParameters['fromDate'] != null) {
      queryParameters['fromDate'] = requestParameters['fromDate']
    }

    if (requestParameters['toDate'] != null) {
      queryParameters['toDate'] = requestParameters['toDate']
    }

    if (requestParameters['limit'] != null) {
      queryParameters['limit'] = requestParameters['limit']
    }

    if (requestParameters['offset'] != null) {
      queryParameters['offset'] = requestParameters['offset']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOrderGetListFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderGetList(
    requestParameters: OrderGetListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOrderGetList> {
    const response = await this.orderGetListRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async orderGetOneRaw(
    requestParameters: OrderGetOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOrderGetOne>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderGetOne().',
      )
    }

    if (requestParameters['orderId'] == null) {
      throw new runtime.RequiredError(
        'orderId',
        'Required parameter "orderId" was null or undefined when calling orderGetOne().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order/{orderId}`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )
    urlPath = urlPath.replace(
      `{${'orderId'}}`,
      encodeURIComponent(String(requestParameters['orderId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOrderGetOneFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderGetOne(
    requestParameters: OrderGetOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOrderGetOne> {
    const response = await this.orderGetOneRaw(requestParameters, initOverrides)
    return await response.value()
  }

  /**
   */
  async orderGetSumsInShopRaw(
    requestParameters: OrderGetSumsInShopRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOrderGetSums>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderGetSumsInShop().',
      )
    }

    if (requestParameters['shopId'] == null) {
      throw new runtime.RequiredError(
        'shopId',
        'Required parameter "shopId" was null or undefined when calling orderGetSumsInShop().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order/total/shop/{shopId}`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )
    urlPath = urlPath.replace(
      `{${'shopId'}}`,
      encodeURIComponent(String(requestParameters['shopId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOrderGetSumsFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderGetSumsInShop(
    requestParameters: OrderGetSumsInShopRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOrderGetSums> {
    const response = await this.orderGetSumsInShopRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async orderGetSumsInShopPaymentPointRaw(
    requestParameters: OrderGetSumsInShopPaymentPointRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOrderGetSums>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderGetSumsInShopPaymentPoint().',
      )
    }

    if (requestParameters['shopId'] == null) {
      throw new runtime.RequiredError(
        'shopId',
        'Required parameter "shopId" was null or undefined when calling orderGetSumsInShopPaymentPoint().',
      )
    }

    if (requestParameters['shopSalePointId'] == null) {
      throw new runtime.RequiredError(
        'shopSalePointId',
        'Required parameter "shopSalePointId" was null or undefined when calling orderGetSumsInShopPaymentPoint().',
      )
    }

    if (requestParameters['shopPaymentPointId'] == null) {
      throw new runtime.RequiredError(
        'shopPaymentPointId',
        'Required parameter "shopPaymentPointId" was null or undefined when calling orderGetSumsInShopPaymentPoint().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order/total/shop/{shopId}/shopSalePoint/{shopSalePointId}/shopPaymentPoint/{shopPaymentPointId}`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )
    urlPath = urlPath.replace(
      `{${'shopId'}}`,
      encodeURIComponent(String(requestParameters['shopId'])),
    )
    urlPath = urlPath.replace(
      `{${'shopSalePointId'}}`,
      encodeURIComponent(String(requestParameters['shopSalePointId'])),
    )
    urlPath = urlPath.replace(
      `{${'shopPaymentPointId'}}`,
      encodeURIComponent(String(requestParameters['shopPaymentPointId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOrderGetSumsFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderGetSumsInShopPaymentPoint(
    requestParameters: OrderGetSumsInShopPaymentPointRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOrderGetSums> {
    const response = await this.orderGetSumsInShopPaymentPointRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async orderGetSumsInShopPaymentPointsRaw(
    requestParameters: OrderGetSumsInShopPaymentPointsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOrderGetSums>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderGetSumsInShopPaymentPoints().',
      )
    }

    if (requestParameters['shopId'] == null) {
      throw new runtime.RequiredError(
        'shopId',
        'Required parameter "shopId" was null or undefined when calling orderGetSumsInShopPaymentPoints().',
      )
    }

    if (requestParameters['shopSalePointId'] == null) {
      throw new runtime.RequiredError(
        'shopSalePointId',
        'Required parameter "shopSalePointId" was null or undefined when calling orderGetSumsInShopPaymentPoints().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order/total/shop/{shopId}/shopSalePoint/{shopSalePointId}/shopPaymentPoint`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )
    urlPath = urlPath.replace(
      `{${'shopId'}}`,
      encodeURIComponent(String(requestParameters['shopId'])),
    )
    urlPath = urlPath.replace(
      `{${'shopSalePointId'}}`,
      encodeURIComponent(String(requestParameters['shopSalePointId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOrderGetSumsFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderGetSumsInShopPaymentPoints(
    requestParameters: OrderGetSumsInShopPaymentPointsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOrderGetSums> {
    const response = await this.orderGetSumsInShopPaymentPointsRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async orderGetSumsInShopSalePointRaw(
    requestParameters: OrderGetSumsInShopSalePointRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOrderGetSums>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderGetSumsInShopSalePoint().',
      )
    }

    if (requestParameters['shopId'] == null) {
      throw new runtime.RequiredError(
        'shopId',
        'Required parameter "shopId" was null or undefined when calling orderGetSumsInShopSalePoint().',
      )
    }

    if (requestParameters['shopSalePointId'] == null) {
      throw new runtime.RequiredError(
        'shopSalePointId',
        'Required parameter "shopSalePointId" was null or undefined when calling orderGetSumsInShopSalePoint().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order/total/shop/{shopId}/shopSalePoint/{shopSalePointId}`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )
    urlPath = urlPath.replace(
      `{${'shopId'}}`,
      encodeURIComponent(String(requestParameters['shopId'])),
    )
    urlPath = urlPath.replace(
      `{${'shopSalePointId'}}`,
      encodeURIComponent(String(requestParameters['shopSalePointId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOrderGetSumsFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderGetSumsInShopSalePoint(
    requestParameters: OrderGetSumsInShopSalePointRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOrderGetSums> {
    const response = await this.orderGetSumsInShopSalePointRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async orderGetSumsInShopSalePointsRaw(
    requestParameters: OrderGetSumsInShopSalePointsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOrderGetSums>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderGetSumsInShopSalePoints().',
      )
    }

    if (requestParameters['shopId'] == null) {
      throw new runtime.RequiredError(
        'shopId',
        'Required parameter "shopId" was null or undefined when calling orderGetSumsInShopSalePoints().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order/total/shop/{shopId}/shopSalePoint`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )
    urlPath = urlPath.replace(
      `{${'shopId'}}`,
      encodeURIComponent(String(requestParameters['shopId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOrderGetSumsFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderGetSumsInShopSalePoints(
    requestParameters: OrderGetSumsInShopSalePointsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOrderGetSums> {
    const response = await this.orderGetSumsInShopSalePointsRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async orderGetSumsInShopsRaw(
    requestParameters: OrderGetSumsInShopsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOrderGetSums>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderGetSumsInShops().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order/total/shop`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOrderGetSumsFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderGetSumsInShops(
    requestParameters: OrderGetSumsInShopsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOrderGetSums> {
    const response = await this.orderGetSumsInShopsRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   */
  async orderUpdateOneRaw(
    requestParameters: OrderUpdateOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResponseOrderGetOne>> {
    if (requestParameters['enterpriseId'] == null) {
      throw new runtime.RequiredError(
        'enterpriseId',
        'Required parameter "enterpriseId" was null or undefined when calling orderUpdateOne().',
      )
    }

    if (requestParameters['orderId'] == null) {
      throw new runtime.RequiredError(
        'orderId',
        'Required parameter "orderId" was null or undefined when calling orderUpdateOne().',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('headerAuthorizationBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }

    let urlPath = `/enterprise/{enterpriseId}/order/{orderId}`
    urlPath = urlPath.replace(
      `{${'enterpriseId'}}`,
      encodeURIComponent(String(requestParameters['enterpriseId'])),
    )
    urlPath = urlPath.replace(
      `{${'orderId'}}`,
      encodeURIComponent(String(requestParameters['orderId'])),
    )

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RequestOrderCreateOneToJSON(
          requestParameters['requestOrderCreateOne'],
        ),
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      ResponseOrderGetOneFromJSON(jsonValue),
    )
  }

  /**
   */
  async orderUpdateOne(
    requestParameters: OrderUpdateOneRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResponseOrderGetOne> {
    const response = await this.orderUpdateOneRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }
}
